import HTMLReactParser from "html-react-parser"
import React, {useEffect} from "react"
import "./blockTwoCol.scss"
import { Container, Row, Col } from "react-bootstrap"
import {graphql} from "gatsby";

const BlkTwoCol = ({content}) => {
    useEffect(() => {
        var acc = document.getElementsByTagName("dt")
        var i

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active")
                var panel = this.nextElementSibling

                if (panel.style.display === "block") {
                    panel.style.display = "none"
                } else {
                    panel.style.display = "block"
                }
            })
        }
    })

  return(
      <section className="blk-twoCol">
          <Container>
              {content.title && (
                  <h2>
                      {content.title}
                  </h2>
              )}

              <Row>
                  <Col md={6} xs={12}>
                      <div>
                          {HTMLReactParser(content.relationships.block_two_columns_layout_col_1.column_item_content.processed)}
                      </div>
                  </Col>
                  <Col md={6} xs={12}>
                      <div>
                          {HTMLReactParser(content.relationships.block_two_columns_layout_col_2.column_item_content.processed)}
                      </div>
                  </Col>
              </Row>
          </Container>
      </section>
  )
}
export const query = graphql`
  fragment blockTwoColumn on paragraph__block_two_columns_layout {
    internal{
        type
    }
    id
    title
    relationships {
      block_two_columns_layout_col_1 {
        column_item_content {
          processed
        }
      }
      block_two_columns_layout_col_2 {
        column_item_content {
          processed
        }
      }
    }
  }
`

export default BlkTwoCol